import styled from 'styled-components'

export const AccordionIcon = styled.div`
  border-radius: 50%;
  position: relative;
  display: inline-block;
  border: 1px solid;
  width: 4rem;
  height: 4rem;
  line-height: 2rem;
  font-family: serif;

  &:after {
    width: 2.4rem;
    height: 2.4rem;
    content: url(../minus.svg);
    position: absolute;
    left: 0.7rem;
    top: 0.7rem;
  }
`

export const AccordionComponent = styled.div`
  .accordian-header[aria-selected='false'] {

    ${AccordionIcon} {
      &:after {
        content: url(../plus.svg);
      }
    }
  }
`

export const ProductStyle = styled.div`
  display: flex !important;
  flex-direction: column;

  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .accordian-header {
    margin: 2.4rem;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      margin: 3rem;
    }
  }
  .productImageContainer {
    position: relative;
    background-size: cover;
    background-position: center;
    margin-bottom: 3.2rem;

    &.hasBackground {
      padding: 4rem;
    }

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      display: flex;
      flex: 0 1 45%;
      margin-bottom: 0;

      &.hasBackground {
        padding: 6rem 0;
        margin-top: -2.5rem;
      }
    }
  }

  .productImage {
    max-width: 85%;
    margin: auto;
    max-height: 100%;
    width: auto;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      max-width: 80%;
      height: auto;
      max-height: 35rem;
    }
  }

  .productDescription {
    margin-top: 1.5rem;
    margin-bottom: 2.5rem;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      margin-bottom: 6.4rem;
    }
  }

  .productDetails {
    flex: 1;
    text-align: center;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      text-align: left;
      flex: 0 1 50%;
    }

    h4 {
      line-height: 1;
    }

    .productLogos {
      display: flex;
      justify-content: center;
      margin: 1.5rem 0;

      @media screen and (min-width: ${props => props.theme.responsive.small}) {
        justify-content: flex-start;
        margin-top: 0;
        margin-bottom: 3.2rem;
      }
    }
    img {
      height: 2.2rem;
      width: auto;
      border-right: 1px solid ${props => props.theme.colors.imageBorder};
      padding-right: 2rem;
      margin-right: 2rem;

      @media screen and (min-width: ${props => props.theme.responsive.small}) {
        height: 3.2rem;
      }

      &:last-child {
        border: 0;
        margin: 0;
        padding: 0;
      }
    }
  }

  .productSpec {
    display: block;

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      display: none;
    }
  }

  .desktopDesc {
    display: none;

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      display: block;
    }
  }
`
